// =============================================================================
// PETSCH LANDING — ZENTRALE KONFIGURATION
// -----------------------------------------------------------------------------
// In dieser Datei findest du ALLE Texte, Links und Inhalte der Webseite.
// Wenn du etwas ändern willst (Tagline, Social-Links, Sendezeiten, E-Mail-
// Adresse usw.), bearbeite es hier — du musst keine anderen Dateien anfassen.
// =============================================================================

// -----------------------------------------------------------------------------
// 1. LOGO & TAGLINE (ganz oben auf der Startseite)
// -----------------------------------------------------------------------------
import {
  InstagramIcon,
  FacebookIcon,
  SoundcloudIcon,
  TwitchIcon,
  HeadphonesIcon,
  CloudIcon,
} from "@/icons";

/** Pfad zum großen Petsch-Logo (liegt in /public/logos/) */
export const LOGO_PATH = "/logos/petsch.png";

/** Drei Genres unter dem Logo — frei änderbar */
export const TAGLINE = ["Techno", "Hands Up", "Tech-House"];


// -----------------------------------------------------------------------------
// 2. RADIO-SHOWS
// -----------------------------------------------------------------------------
// Für jede Radioshow eine Karte. Reihenfolge bestimmt die Anzeige (links/rechts).
// `img` zeigt auf eine Datei in /public/logos/.
// `schedule` ist die Anzeigetext der Sendezeit.
// `testId` dient internen Tests — kann unverändert bleiben.
// -----------------------------------------------------------------------------
export const RADIO_SHOWS = [
  {
    name: "TechnoBase.FM",
    label: "Live Radioshow",
    schedule: "Mittwochs · 20 – 22 Uhr",
    url: "https://www.technobase.fm",
    img: "/logos/technobase.png",
    testId: "radio-technobase",
  },
  {
    name: "HouseTime.FM",
    label: "Live Radioshow",
    schedule: "Sonntags · 20 – 22 Uhr",
    url: "https://www.housetime.fm",
    img: "/logos/housetime.png",
    testId: "radio-housetime",
  },
];


// -----------------------------------------------------------------------------
// 3. SOCIAL-MEDIA-LINKS
// -----------------------------------------------------------------------------
// Reihenfolge entspricht der Anzeige im 3×2-Raster (Desktop) bzw. 2×3 (Mobile).
// `Icon` ist eine React-Komponente aus /src/icons.jsx.
// -----------------------------------------------------------------------------
export const SOCIALS = [
  {
    name: "Instagram",
    Icon: InstagramIcon,
    url: "https://www.instagram.com/petschmusic/",
    testId: "social-instagram",
  },
  {
    name: "Facebook",
    Icon: FacebookIcon,
    url: "https://www.facebook.com/djpetsch",
    testId: "social-facebook",
  },
  {
    name: "Mixcloud",
    Icon: CloudIcon,
    url: "https://www.mixcloud.com/petsch/",
    testId: "social-mixcloud",
  },
  {
    name: "Hearthis.at",
    Icon: HeadphonesIcon,
    url: "https://hearthis.at/petsch/",
    testId: "social-hearthis",
  },
  {
    name: "Soundcloud",
    Icon: SoundcloudIcon,
    url: "https://soundcloud.com/user-991021289",
    testId: "social-soundcloud",
  },
  {
    name: "Twitch",
    Icon: TwitchIcon,
    url: "https://www.twitch.tv/petschmusic",
    testId: "social-twitch",
  },
];


// -----------------------------------------------------------------------------
// 4. BOOKING (E-Mail-Anfrage)
// -----------------------------------------------------------------------------
export const BOOKING = {
  email: "booking@petsch.live",
  // Betreff und Text werden in das Mail-Programm vorausgefüllt
  subject: "Booking Anfrage",
  body:
    "Hallo Petsch,\n\n" +
    "Ich möchte dich für folgendes Event anfragen:\n\n" +
    "Datum:\n" +
    "Veranstaltung:\n" +
    "Ort:\n" +
    "Zeitraum:\n" +
    "Kontakt:\n\n" +
    "Viele Grüße",
};


// -----------------------------------------------------------------------------
// 5. DISCORD & KO-FI BUTTONS
// -----------------------------------------------------------------------------
export const DISCORD_URL = "https://discord.gg/zEHMDKCzAU";
export const KOFI_URL = "https://ko-fi.com/petsch";


// -----------------------------------------------------------------------------
// 6. UPCOMING EVENTS — Google-Sheet-CSV
// -----------------------------------------------------------------------------
// Veröffentlichte CSV-URL deines Google Sheets.
// Sheet pflegen: Spalten "date" (YYYY-MM-DD), "event", "location".
// Max. 10 zukünftige Events werden angezeigt, vergangene automatisch ausgeblendet.
// -----------------------------------------------------------------------------
export const EVENTS_CSV_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vRRH6hu8aVtXNwU3H3m1Pstd7PgiRjdOEyf788mkR_Ai9YEPTb17zjgQCwWoTPYdWl9HDntMZUU1GCs/pub?gid=0&single=true&output=csv";

/** Maximale Anzahl angezeigter Events */
export const EVENTS_MAX = 10;


// -----------------------------------------------------------------------------
// 7. IMPRESSUM-DATEN
// -----------------------------------------------------------------------------
export const IMPRESSUM = {
  name: "Patrick Knoll",
  street: "Hauptstr. 32",
  city: "72505 Krauchenwies",
  country: "Deutschland",
  contactEmail: "info@petsch.live",
};


// -----------------------------------------------------------------------------
// 8. ANIMATION & DESIGN
// -----------------------------------------------------------------------------
/** Anzahl der schwebenden Hintergrund-Partikel. Mehr = aufwendiger. */
export const PARTICLE_COUNT = 16;
